import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const formatPhoneNumberToInternational = (number) => {
	if (!number) return null;
	number = typeof number === 'string' ? number : number.toString();
	const phoneNumber = parsePhoneNumberFromString(
		number,
		process.env.REACT_APP_PHONE_DEFAULT
	);
	if (!phoneNumber || phoneNumber === null || phoneNumber === undefined)
		return number;
	return phoneNumber.formatInternational();
};

export const cleanPhoneNumber = (number, hasPrefix) => {
	if (!number) return '';
	//if (number === '+352') return '';
	if (number.startsWith('00')) number = number.replace(/^00/, '+');
	if (!number.startsWith('+') && !hasPrefix)
		number = `${process.env.REACT_APP_DEFAULT_PHONE_COUNTRY_CODE}${number}`;
	else if (!number.startsWith('+') && hasPrefix) number = `+${number}`;
	return number;
};

export const checkPrefixePhoneNumer = (phone) => {
	return !phone || phone.startsWith('00') || phone.startsWith('+')
}

export const isSamePhoneNumber = (phone1, phone2) => {
	if (!phone1 || !phone2) return false;
	if(phone1 === phone2) return true;
	if (phone1.startsWith('00')) phone1 = phone1.replace(/^00/, '+');
	if (phone2.startsWith('00')) phone2 = phone2.replace(/^00/, '+');
	if(phone1 === phone2) return true;
	return false;

}
